import { useQuery } from '@tanstack/react-query';
import type {
  AllergySearchPagedListResponseT,
  SearchAllergensParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSearchAllergens } from '../api/searchAllergens.js';
import { rxKeys } from './keys.js';

export function searchAllergensQueryDefinition(params: SearchAllergensParams) {
  return {
    queryKey: rxKeys.allergensSearch(params),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSearchAllergens(params, signal),
    meta: {
      toast: {
        title: 'Could not search allergens',
        description: 'Allergen search could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function useSearchAllergensQuery(params: SearchAllergensParams | undefined) {
  const enabled = Boolean(params && params.name.trim().length >= 3);

  return useQuery({
    queryKey: params
      ? rxKeys.allergensSearch(params)
      : (['rx', 'allergens', 'search', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<AllergySearchPagedListResponseT> => {
      if (!params) {
        throw new Error('Missing allergens search params');
      }
      return fetchSearchAllergens(params, signal);
    },
    enabled,
  });
}
